const allowedProtocols = new Set(['http:', 'https:']);

/**
 * Turns a user-supplied link (for example a profile URL typed into a KYC form)
 * into something safe to open from the admin app, or undefined if it is not.
 *
 * Only http and https are allowed. A `javascript:` or `data:` URL passed to
 * window.open runs in the admin app's origin, where the admin token lives, so
 * such values must never be opened. A value with no scheme at all, such as
 * `linkedin.com/in/someone`, is treated as https.
 */
export const toSafeExternalUrl = (
  value?: string | null,
): string | undefined => {
  const trimmed = value?.trim();
  if (!trimmed) {
    return undefined;
  }
  const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(trimmed);
  const candidate = hasScheme ? trimmed : `https://${trimmed}`;
  try {
    const url = new URL(candidate);
    return allowedProtocols.has(url.protocol) ? url.toString() : undefined;
  } catch {
    return undefined;
  }
};
